import React, { Component } from 'react';
import { Layout } from 'antd';

import './NotFound.css';

const { Content } = Layout;

class NotFound extends Component {
	render(){
		return (
			<Content>
				<h1>ไม่พบหน้าที่ต้องการ</h1>
			</Content>
		)
	}
}

export default NotFound


// WEBPACK FOOTER //
// ./src/containers/NotFound/index.js